import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconAssign(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M21 1a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0V5h2a1 1 0 1 0 0-2h-2V1Z"
        fill="currentColor"
      />
      <path
        d="M14.706 2.727A3.003 3.003 0 0 0 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9.618A1.494 1.494 0 0 1 20 10c-.384 0-.735-.144-1-.382V19H5V5h9.382a1.499 1.499 0 0 1 .324-2.273Z"
        fill="currentColor"
      />
      <path
        d="M9 9c0-1.65 1.35-3 3-3s3 1.35 3 3-1.35 3-3 3-3-1.35-3-3ZM6 16.47V18h12v-1.53c0-2.5-3.97-3.58-6-3.58s-6 1.07-6 3.58Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
